<ng-content select="[header-row]"></ng-content>

<div
  class="overflow-hidden"
  [@bodyExpansion]="isExpanded ? 'expanded' : 'collapsed'"
  [ngClass]="{
    'overflow-visible': isExpandedBugfix,
    'overflow-hidden': !isExpandedBugfix,
  }"
>
  <ng-content select="[content-row]"></ng-content>
</div>
